import { store } from "../store/index";
import {
  getStandAloneProcessData,
  register,
  addBB,
  finish,
  remove,
  registerExpedition,
  getExpeditionData,
  addBBExp,
  removeExp,
  finishExp,
  removeStandAloneProcess,
} from "../store/actions/StandAloneProcessAction";

/**
 * List items
 */
export const getStandAloneProcess = async (type) => {
  const result = await store.dispatch(getStandAloneProcessData([type]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const createStandAloneProcess = async (values, type) => {
  delete values.outPoint;
  values.type = "IN";
  const result = await store.dispatch(register(values, [type]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const registerBB = async (values, type, processType) => {
  values.type = type;
  if (type === "IN") {
    delete values.outPoint;
  }
  const result = await store.dispatch(addBB(values, [processType]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const finishStandAloneProcess = async (processType) => {
  const result = await store.dispatch(finish([processType]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Remove item standAloneProcess
 */
export const removeItem = async (uuid, processType) => {
  const result = await store.dispatch(remove([uuid, processType]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const createExpedition = async (values) => {
  delete values.outPoint;
  values.type = "IN";
  const result = await store.dispatch(registerExpedition(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List items
 */
export const getExpedition = async () => {
  const result = await store.dispatch(getExpeditionData());
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const registerBBExp = async (values, type) => {
  values.type = type;
  if (type === "IN") {
    delete values.outPoint;
  }
  const result = await store.dispatch(addBBExp(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Remove item standAloneProcess
 */
export const removeItemExp = async (uuid) => {
  const result = await store.dispatch(removeExp([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const finishStandAloneProcessExp = async () => {
  const result = await store.dispatch(finishExp());
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};


/**
 * Remove standAloneProcess
 */
export const deleteStandAloneProcess = async (uuid) => {
  const result = await store.dispatch(removeStandAloneProcess([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
